<template>
  <div>
    <van-nav-bar placeholder title="我的课程" >
    </van-nav-bar>
    <!--下拉刷新-->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">

      <!--分页列表-->
      <van-list
          class="my-list"
          v-model="data.bottomLoading"
          :finished="!data.hasMore"
          finished-text="没有更多了"
          @load="bottomRefresh()"
      >
          <div class="mykc-box" v-for="(item,index) in  data.records" :key="index">
                  <div class="jg-list-top"  @click="getUnpaid(item)">
                    <img v-if="item.pic" :src="fileDisplayPrefix +  (item.pic || '').split(',')[0]"/>
                    <img v-else src="@/assets/patternless.png">
                    <div class="jg-right">
                      <h2><a href="#">{{item.curriculumName}}</a></h2>
                      <span class="time">时间：{{item.classTime}}</span>
                      <span>学员：{{item.studentName}}</span>
                      <span>
                        课时：
                        {{item.classHour}}/{{item.classHour - item.leftHour}}
                        <i class="t0" v-if="item.status =='0'">{{item.statusName}}</i><!-- 待支付 -->
                        <i class="t1" v-if="item.status =='1'">{{item.statusName}}</i><!-- 在读 -->
                        <i class="t2" v-if="item.status =='2'">{{item.statusName}}</i><!-- 退费中 -->
                        <i class="t3" v-if="item.status =='3'">{{item.statusName}}</i><!-- 已退费 -->
                        <i class="t4" v-if="item.status =='4'">{{item.statusName}}</i><!-- 已结课 -->
                        <i class="t5" v-if="item.status =='9'">{{item.statusName}}</i><!-- 已取消 -->
                      </span>
                    </div>
                  </div>
                  <div class="jg-bottom" v-if="item.status =='1' || item.status =='4'" style="justify-content: center">
                    <i class="t0 jg-but"  @click="getScore(item)">评价</i>
                  </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>

import {handlePageData} from "../../utils/common";
import {coursePage} from "../../api/course/course";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";

export default {
  name: 'service',
  components: {},
  data() {
    return {
      fileDisplayPrefix:FILE_DISPLAY_PREFIX,
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      queryParams: {},
    }
  },
  computed: {},
  created() {
    this.refresh()
  },
  mounted() {
  },
  methods: {
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size
      coursePage(this.queryParams).then(res => {
        if (res.code === 10000) {
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    },


    refresh() {
      this.reset();
      this.getList();
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },

    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    getScore(res){
      this.$router.push({path: `/course/score?id=${res.id}`})
    },

    getUnpaid(res){
      if ('0' ===res.status || '9' ===res.status){
        this.$router.push({path: `/course/unpaid?id=${res.id}`})
      }else if('1' === res.status){
        this.$router.push({path: `/course/reading` , query: {id: res.id}})
      }else if ('2' === res.status || '3' === res.status){
        this.$router.push({path: `/course/auditDetail?id=${res.id}`})
      }


    }
  }
}
</script>

<style scoped>
.jg-but{
  background: #66C779;
}
.my-list{
  background: #f2f6fd;
  padding:10px;
}
.mykc-box{
  /*height:108px;*/
  background: #ffffff;
  border-radius:12px;
  margin-bottom: 10px;
  box-shadow: 0px 3px 40px 0px rgba(0,0,0,0.07);
}
.jg-right span{
  width: 100%;
  justify-content: space-between;
}
.jg-right span i{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding:5px 6px;
  border-radius:12px;
  position: absolute;
  top: -5px;
  right: 0;
  min-width: 50px;
}
.jg-right span i.t0{
  background: #FF9900;
}
.jg-right span i.t1{
  background: #66C779;
}
.jg-right span i.t2{
  background: #66C779;
}
.jg-right span i.t3{
  background: #A37FFF;
}
.jg-right span i.t4{
  background: #A7A7A7;
}
.jg-right span i.t5{
  background: #A7A7A7;
}
.jg-bottom i.jg-but{
 margin-bottom: 10px;
}
</style>
